export default function XQuery_HTML() {
  return (
    <div>
      <h1>XQuery_HTML</h1>
      <p>This is the XQuery_HTML component.</p>
    </div>
  );
}